import React, { FC, useEffect } from "react";
import { Form, Radio, Input, Row, Col } from "antd";

interface EchsEmergencyClinicalFindingsFormProps {
  form: any;
  loading?: boolean;
  disabled: any;
}

const clinicalConditions = [
  {
    key: "bp",
    label: "BLOOD PRESSURE",
    valuePrefix: "1",
  },
  {
    key: "cvs",
    label: "CARDIOVASCULAR SYSTEM",
    valuePrefix: "2",
  },
  {
    key: "rs",
    label: "RESPIRATORY SYSTEM",
    valuePrefix: "3",
  },
  {
    key: "abdomen",
    label: "ABDOMEN",
    valuePrefix: "4",
  },
  {
    key: "cns",
    label: "CENTRAL NERVOUS SYSTEM",
    valuePrefix: "5",
  },
  {
    key: "covid",
    label: "COVID",
    valuePrefix: "6",
  },
  {
    key: "clinicalOther",
    label: "OTHER",
    valuePrefix: "99",
  },
];

const EchsEmergencyClinicalFindingsForm: FC<
  EchsEmergencyClinicalFindingsFormProps
> = ({ form, loading, disabled }) => {
  useEffect(() => {
    // Initialize form with default N.M. values
    // const initialValues = clinicalConditions.reduce(
    //   (acc, condition) => ({
    //     ...acc,
    //     [condition.key]: `${condition.valuePrefix}:M`,
    //     [`${condition.key}Value`]: "",
    //   }),
    //   {}
    // );

    const initialValues = clinicalConditions.reduce((acc, condition) => {
      // Special case for medicalManagement
      if (condition.key === "bp") {
        return {
          ...acc,
          [condition.key]: `${condition.valuePrefix}:Y`,
          [`${condition.key}Value`]: "130/90",
        };
      }

      return {
        ...acc,
        [condition.key]: `${condition.valuePrefix}:M`,
        [`${condition.key}Value`]: "",
      };
    }, {});

    if (Object.keys(form.getFieldValue("patientClinicalFindings") || {})?.length === 0) {
      form.setFieldsValue({
        patientClinicalFindings: initialValues,
      });
    }
  }, [form]);

  const handleChange = (name: string, value: string) => {
    const currentValues = form.getFieldValue("patientClinicalFindings") || {};
    const [prefix] = value.split(":");
    const isYes = value.toLowerCase().includes("y");

    form.setFieldsValue({
      patientClinicalFindings: {
        ...currentValues,
        [name]: value,
        [`${name}Value`]: isYes ? currentValues[`${name}Value`] || "" : "",
      },
    });
  };

  const handleValueChange = (name: string, value: string) => {
    const currentValues = form.getFieldValue("patientClinicalFindings") || {};
    form.setFieldsValue({
      patientClinicalFindings: {
        ...currentValues,
        [`${name}Value`]: value,
      },
    });
  };

  const ClinicalFindingField = ({
    condition,
  }: {
    condition: (typeof clinicalConditions)[0];
  }) => {
    const fieldValue = Form.useWatch(
      ["patientClinicalFindings", condition.key],
      form
    );
    const inputValue = Form.useWatch(
      ["patientClinicalFindings", `${condition.key}Value`],
      form
    );
    const showInput = fieldValue?.toLowerCase()?.includes("y");

    return (
      <Row key={condition.key} gutter={[24, 24]}>
        <Col span={24}>
          <Form.Item label={condition.label} required={false}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item
                  noStyle
                  name={["patientClinicalFindings", condition.key]}
                >
                  <Radio.Group
                    onChange={(e) =>
                      handleChange(condition.key, e.target.value)
                    }
                    disabled={disabled}
                  >
                    <Radio value={`${condition.valuePrefix}:Y`}>YES</Radio>
                    <Radio value={`${condition.valuePrefix}:N`}>NO</Radio>
                    <Radio value={`${condition.valuePrefix}:M`}>N.M.</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {showInput && (
                <Col span={12}>
                  <Form.Item
                    noStyle
                    name={["patientClinicalFindings", `${condition.key}Value`]}
                  >
                    <Input
                      placeholder={`Enter ${condition.label} Value`}
                      onChange={(e) =>
                        handleValueChange(condition.key, e.target.value)
                      }
                      value={inputValue}
                      disabled={disabled}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Form.Item>
        </Col>
      </Row>
    );
  };

  return (
    <div className="echs-emergency-clinical-findings">
      <Form form={form} layout="vertical" requiredMark>
        {clinicalConditions?.map((condition) => (
          <ClinicalFindingField key={condition.key} condition={condition} />
        ))}
      </Form>
    </div>
  );
};

export default EchsEmergencyClinicalFindingsForm;
